/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to create a task box
 * @export
 * @interface AddOrUpdateTaskBoxRequest
 */
export interface AddOrUpdateTaskBoxRequest {
    /**
     * 
     * @type {string}
     * @memberof AddOrUpdateTaskBoxRequest
     */
    id?: string;
    /**
     * The task box name
     * @type {string}
     * @memberof AddOrUpdateTaskBoxRequest
     */
    title?: string;
    /**
     * The task box module type
     * @type {string}
     * @memberof AddOrUpdateTaskBoxRequest
     */
    moduleType?: string;
}

/**
 * Check if a given object implements the AddOrUpdateTaskBoxRequest interface.
 */
export function instanceOfAddOrUpdateTaskBoxRequest(value: object): value is AddOrUpdateTaskBoxRequest {
    return true;
}

export function AddOrUpdateTaskBoxRequestFromJSON(json: any): AddOrUpdateTaskBoxRequest {
    return AddOrUpdateTaskBoxRequestFromJSONTyped(json, false);
}

export function AddOrUpdateTaskBoxRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddOrUpdateTaskBoxRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'moduleType': json['moduleType'] == null ? undefined : json['moduleType'],
    };
}

export function AddOrUpdateTaskBoxRequestToJSON(json: any): AddOrUpdateTaskBoxRequest {
    return AddOrUpdateTaskBoxRequestToJSONTyped(json, false);
}

export function AddOrUpdateTaskBoxRequestToJSONTyped(value?: AddOrUpdateTaskBoxRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'moduleType': value['moduleType'],
    };
}

